import { CompanyExcel } from "../../domain/entities/CompanyExcel"
import { CompanyExcelModel } from "../models/CompanyExcelModel"
import { HttpManager } from "../network/interface/HttpManager"
import { UploadCompanyExcelDTO } from "../dto/UploadCompanyExcel.dto"

interface Props {
	HttpManager: HttpManager
}

export class CompanyExcelService {
	private _httpClient: HttpManager

	constructor({ HttpManager }: Props) {
		this._httpClient = HttpManager
	}

	async getCompanyExcels(): Promise<CompanyExcel[]> {
		const response = await this._httpClient.requestNewApi({
			url: "/company-excel/admin/list",
			method: "GET"
		})
		return response.data.map((item: any) => new CompanyExcelModel(item).toDomain())
	}

	async uploadCompanyExcel(data: UploadCompanyExcelDTO): Promise<{ success: boolean; message: string }> {
		const formData = new FormData()
		formData.append("file", data.file, data.file.name)
		formData.append("micrositeId", data.micrositeId.toString())
		formData.append("userId", data.userId.toString())

		const response = await this._httpClient.requestNewApi({
			url: "/company-excel/admin/upload",
			method: "POST",
			data: formData,
			headers: {
				"Content-Type": "multipart/form-data"
			}
		})
		return response.data
	}

	async sendEmail(companyExcelId: number): Promise<{ success: boolean; message: string }> {
		const response = await this._httpClient.requestNewApi({
			url: `/company-excel/admin/${companyExcelId}/send-email`,
			method: "POST"
		})
		return response.data
	}
}
